/*
 * First-party measurement for upliance.ai (no WebEngage dependency).
 * Config + uplTrack() come from snippets/upl-measure.liquid.
 *
 * Shared contract with food.upliance.ai (upliance-recipes-digest: src/lib/upl-measure.ts) and
 * insight-stream. Keep cookie names, touch shape and event names identical across repos.
 * Spec: reference docs/first-party-measurement.md
 *
 *   cookies  upl_ft  first visit ever (incl. direct), 365d, on .upliance.ai
 *            upl_lt  last non-direct touch (ad click / UTM / external referrer), 90d
 *   cart     _upl_ga_cid, _upl_ga_sid, _upl_ft, _upl_lt  -> order customAttributes
 *   GA4      page_engaged {engaged_ms, page_engaged_ms, max_scroll_pct, flush}
 *            link_out     {link_domain, link_path, cta, recipe_id, brand_site}
 */
(function () {
  var UPL = window.UPL;
  if (!UPL || UPL.started) return;
  UPL.started = true;
  var track = window.uplTrack;

  /* ---------- cookies ---------- */
  // Production only (published theme, not the editor or a preview): see UPL.live in the snippet.
  // ?upl_debug=1 enables cookies + cart stamping elsewhere for testing, host-only.
  var ACTIVE = UPL.live || UPL.debug;
  var ON_ROOT = UPL.live;
  function getCookie(name) {
    var m = document.cookie.match('(?:^|; )' + name + '=([^;]*)');
    if (!m) return null;
    try { return decodeURIComponent(m[1]); } catch (e) { return m[1]; }
  }
  function setCookie(name, value, days) {
    document.cookie = name + '=' + encodeURIComponent(value) + '; path=/; max-age=' + days * 86400 +
      (ON_ROOT ? '; domain=.upliance.ai' : '') + '; SameSite=Lax' + (location.protocol === 'https:' ? '; Secure' : '');
  }

  /* ---------- GA ids (shared across subdomains via the _ga cookie on .upliance.ai) ---------- */
  function gaClientId() {
    var v = getCookie('_ga'); // GA1.1.1202329901.1790874766
    var p = v ? v.split('.') : [];
    return p.length >= 4 ? p.slice(-2).join('.') : '';
  }
  function gaSessionId() {
    var v = getCookie('_ga_' + UPL.ga4.replace(/^G-/, '')); // GS1.1.1790874766.1... or GS2.1.s1790874766$o1...
    var m = v && v.match(/^GS\d\.\d\.s?(\d+)/);
    return m ? m[1] : '';
  }

  /* ---------- attribution touch ---------- */
  var PARAMS = {
    utm_source: 'src', utm_medium: 'med', utm_campaign: 'cmp', utm_content: 'cnt', utm_term: 'trm', utm_id: 'uid',
    gclid: 'gclid', gbraid: 'gbraid', wbraid: 'wbraid', fbclid: 'fbclid', msclkid: 'msclkid', ttclid: 'ttclid'
  };
  // Hops between our own sites and back from payment pages are not new touches. This also ignores the
  // ad UTMs that food.upliance.ai forwards back on its links.
  var INTERNAL_REF = /(^|\.)(upliance\.ai|myshopify\.com|shopify\.com|shop\.app|razorpay\.com|payu\.in|paytm\.com|phonepe\.com|cashfree\.com|gokwik\.co|shopflo\.co|snapmint\.com|getsimpl\.com)$/;

  function currentTouch() {
    var q = new URLSearchParams(location.search);
    var t = {};
    var tagged = false;
    Object.keys(PARAMS).forEach(function (k) {
      var v = q.get(k);
      if (v) { t[PARAMS[k]] = v.slice(0, 120); tagged = true; }
    });
    var ref = '';
    try { ref = document.referrer ? new URL(document.referrer).hostname : ''; } catch (e) {}
    if (ref && (ref === location.hostname || INTERNAL_REF.test(ref))) return { internal: true };
    if (ref) t.ref = ref;
    t.lp = UPL.site + ':' + location.pathname.slice(0, 100);
    t.ts = Math.floor(Date.now() / 1000);
    t.direct = !tagged && !ref;
    return t;
  }

  var touch = ACTIVE ? currentTouch() : { internal: true };
  if (!touch.internal) {
    var direct = touch.direct;
    delete touch.direct;
    var json = JSON.stringify(touch);
    if (!getCookie('upl_ft')) setCookie('upl_ft', json, 365);
    if (!direct) setCookie('upl_lt', json, 90);
  }

  /* ---------- stamp ids + attribution onto the cart, so the order carries them ---------- */
  var cartTimer;
  function decodeHtml(s) {
    if (!s) return '';
    var t = document.createElement('textarea');
    t.innerHTML = s;
    return t.value;
  }
  function stampCart() {
    if (!ACTIVE) return;
    clearTimeout(cartTimer);
    cartTimer = setTimeout(function () {
      var a = {
        _upl_ga_cid: gaClientId(),
        _upl_ga_sid: gaSessionId(),
        _upl_ft: getCookie('upl_ft') || '',
        _upl_lt: getCookie('upl_lt') || ''
      };
      if (!a._upl_ga_cid && !a._upl_ft) return;
      // Liquid renders a missing attribute as null and Shopify drops empty ones: compare as ''.
      // Liquid's cart.attributes values are HTML-escaped ("&quot;"), so decode before comparing.
      var c = UPL.cartAttrs || {};
      if (decodeHtml(c.cid) === a._upl_ga_cid && decodeHtml(c.ft) === a._upl_ft && decodeHtml(c.lt) === a._upl_lt) return;
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: a }),
        keepalive: true
      }).then(function (r) {
        if (r.ok) UPL.cartAttrs = { cid: a._upl_ga_cid, ft: a._upl_ft, lt: a._upl_lt };
      }).catch(function () {});
    }, 600);
  }
  // Any add/change to the cart, from the theme's product form or a custom section. Our own
  // /cart/update.js call does not match, so this cannot loop.
  try {
    new PerformanceObserver(function (list) {
      list.getEntries().forEach(function (e) {
        if (/\/cart\/(add|change)(\.js)?(\?|$)/.test(e.name)) stampCart();
      });
    }).observe({ type: 'resource' });
  } catch (e) {}

  /* ---------- engaged time + scroll per page ---------- */
  var IDLE_MS = 60000;
  var MAX_PAGE_MS = 30 * 60000;
  var lastAct = Date.now();
  var lastTick = Date.now();
  var active = 0;
  var sent = 0;
  var maxScroll = 0;

  function bump() { lastAct = Date.now(); }
  ['pointerdown', 'pointermove', 'keydown', 'touchstart', 'wheel', 'scroll'].forEach(function (ev) {
    addEventListener(ev, bump, { passive: true, capture: true });
  });
  function scrollPct() {
    var h = document.documentElement.scrollHeight - innerHeight;
    return h > 0 ? Math.min(100, Math.round((scrollY / h) * 100)) : 100;
  }
  function audiblePlaying() {
    // Muted autoplay loops (hero videos) must not count as attention.
    var v = document.querySelectorAll('video');
    for (var i = 0; i < v.length; i++) if (!v[i].paused && !v[i].ended && !v[i].muted) return true;
    return false;
  }
  setInterval(function () {
    var now = Date.now();
    var dt = Math.min(now - lastTick, 2000);
    lastTick = now;
    if (document.visibilityState !== 'visible') return;
    // Recent input on this page proves presence on its own: iOS in-app browsers (Instagram,
    // Facebook) can report hasFocus() === false while the user scrolls. Focus is only required
    // for the "watching an unmuted video without touching anything" case.
    var recentInput = now - lastAct <= IDLE_MS;
    var focused = document.hasFocus() || (document.activeElement && document.activeElement.tagName === 'IFRAME');
    if (!recentInput && !(focused && audiblePlaying())) return;
    if (active < MAX_PAGE_MS) active += dt;
    var s = scrollPct();
    if (s > maxScroll) maxScroll = s;
  }, 1000);

  function flush(reason) {
    var delta = active - sent;
    if (delta < 1000) return;
    sent = active;
    track('page_engaged', {
      engaged_ms: Math.round(delta),
      page_engaged_ms: Math.round(active),
      max_scroll_pct: maxScroll,
      flush: reason,
      transport_type: 'beacon'
    });
  }
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') flush('hidden');
  });
  addEventListener('pagehide', function () { flush('pagehide'); });

  /* ---------- clicks that leave this site (recipe site, demo booking, WhatsApp, ...) ---------- */
  // Capture phase: runs before the WebEngage handlers that preventDefault and redirect.
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest && e.target.closest('a[href]');
    if (!a) return;
    var u;
    try { u = new URL(a.href, location.href); } catch (x) { return; }
    if (!/^https?:$/.test(u.protocol) || u.hostname === location.hostname) return;
    var recipe = u.pathname.match(/\/recipe\/([\w-]+)/);
    track('link_out', {
      link_domain: u.hostname,
      link_path: u.pathname.slice(0, 100),
      cta: u.searchParams.get('cta') || '',
      recipe_id: recipe ? recipe[1] : '',
      brand_site: /(^|\.)upliance\.ai$/.test(u.hostname),
      transport_type: 'beacon'
    });
    flush('link_out');
  }, true);

  /* ---------- after load: stamp an existing cart, tag Clarity with the shared GA id ---------- */
  function afterLoad() {
    setTimeout(function () {
      if (UPL.cartCount > 0) stampCart();
      var cid = gaClientId();
      if (cid && typeof window.clarity === 'function') {
        try { clarity('identify', cid); clarity('set', 'ga_cid', cid); } catch (e) {}
      }
    }, 1500);
  }
  if (document.readyState === 'complete') afterLoad();
  else addEventListener('load', afterLoad);

  UPL.state = function () {
    return { cid: gaClientId(), sid: gaSessionId(), ft: getCookie('upl_ft'), lt: getCookie('upl_lt'),
      activeMs: active, sentMs: sent, maxScroll: maxScroll, cartAttrs: UPL.cartAttrs };
  };
})();
